import React from "react";
import NavMenu from "../Nav/NavMenu";
import Footer from "../footer/Footer";
import emptySliderIcon from "../../assets/static/4_still_curious.webp";
import EmptySlider from "../sliders/EmptySlider";
import { Container, Row, Col, Button } from 'react-bootstrap';
import MoneyskillImage from "../../assets/static/helpcenter/profile_settings.png";

function MoneySkills() {
  return (
    <div>
      <NavMenu></NavMenu>
      <br></br>
      <br></br>
      <EmptySlider
        title="How to Master Your Money with Kontriman"
        description="Strong money skills are key to financial independence. Kontriman helps you budget, save, invest, and understand credit—empowering you to take control of your finances for a secure future."
        imageUrl={emptySliderIcon}
      />
      <div>
        <Container fluid className="my-5 bg-custom">
          <Container className="container-padding">
            <Row className="flex-column flex-md-row">
              {/* Image column */}
              <Col md={6} className="order-2 order-md-1">
                <img
                  src={MoneyskillImage}
                  alt="Money Skills"
                  className="img-fluid"
                />
              </Col>

              {/* Text column */}
              <Col
                md={6}
                className="d-flex align-items-center order-1 order-md-2"
              >
                <div>
                  <h1 className="custom_heading">Master Your Money Skills</h1>
                  <p>
                    At Kontriman Cooperative Credit Union, we believe that
                    financial empowerment starts with education. Our Money
                    Skills program is designed to help individuals, families,
                    and groups build better financial habits and make informed
                    decisions.
                  </p>

                  <h5 className="mt-4">What You’ll Learn</h5>
                  <ul>
                    <li>How to budget effectively and track spending</li>
                    <li>Understanding savings, credit, and debt</li>
                    <li>Setting financial goals and building discipline</li>
                    <li>Protecting yourself from fraud and scams</li>
                  </ul>

                  <h5 className="mt-4">Who It's For</h5>
                  <ul>
                    <li>Students and youth preparing for independence</li>
                    <li>Families looking to manage household expenses</li>
                    <li>
                      Groups or associations organizing financial literacy
                      sessions
                    </li>
                    <li>Anyone interested in improving their money habits</li>
                  </ul>

                  <a href="mailto:info@kontriman.com">
                    <Button className="custom-button mt-3">
                      Join a Session
                    </Button>
                  </a>
                </div>
              </Col>
            </Row>
          </Container>
        </Container>
      </div>
      <Footer></Footer>
    </div>
  );
}

export default MoneySkills;
